// src/data/learningConfig.js
// Zentrale Lern-Parameter. Die Wochenmenge ergibt sich überall aus TARGET_WORDS / Wochen
// (abhängig vom gewählten Tempo) - deshalb nur hier ändern.

// Anzahl Vokabeln, die über die gesamte Lernzeit gelernt werden (Umfang von concepts.csv).
export const TARGET_WORDS = 3000;

// Lerndauer pro Tempo in Jahren. "hard" ist der Bezugspunkt (1 Jahr), die anderen Stufen
// behalten das ursprüngliche Verhältnis (medium = hard / 0,75, easy = medium * 1,5).
export const PACE_YEARS = { easy: 2, medium: 4 / 3, hard: 1 };

// Anzeigetexte für die Tempo-Auswahl und das Hauptmenü.
export const PACE_LABELS = {
  easy: "Leicht · 2 Jahre",
  medium: "Mittel · 16 Monate",
  hard: "Streng · 1 Jahr",
};
